import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import PhoneVerificationForm from "@/components/forms/PhoneVerificationForm/PhoneVerificationForm.vue";
import SettingsDetails from "@/components/settings/SettingsDetails/SettingsDetails.vue";
import { useComputedValue } from "@/composables";
import { useGetConnectPhoneProperties } from "@/composables";
import { updateUserPhoneAsync } from "@/services/maitrejaApi/auth";
import { GetterTypes, MutationTypes } from "@/store";
import { Profile } from "@/store/auth/state";
import { ConnectPhoneHandler } from "@/types/auth";
import { settingsConnectPhoneNumberSnackbarErrorObject } from "@/utils/auth";
import { useRouter } from "vue-router";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsConnectPhoneNumber',
  setup(__props) {

const { commit } = useStore();
const router = useRouter();
const profile = useComputedValue<Profile>(GetterTypes.GET_AUTH_PROFILE);

const handleSubmit: ConnectPhoneHandler = async (data, idToken) => {
  const parsedPhoneNumber = data.phoneNumber.replaceAll(" ", "");
  try {
    await updateUserPhoneAsync(idToken, data.countryCode, parsedPhoneNumber);

    const newProfile: Profile = {
      ...profile.value,
      countryCode: data.countryCode,
      phoneNumber: parsedPhoneNumber,
    };

    commit(MutationTypes.SET_AUTH_PROFILE, newProfile);
    router.back();
  } catch (err) {
    throw err;
  }
};

const { handleRedirectBack, handleTogglePopup, ...otherProps } =
  useGetConnectPhoneProperties(
    handleSubmit,
    settingsConnectPhoneNumberSnackbarErrorObject,
  );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SettingsDetails, {
    title: _ctx.$t('settings.connectPhoneNumber'),
    "handle-redirect": _unref(handleRedirectBack)
  }, {
    default: _withCtx(() => [
      _createVNode(PhoneVerificationForm, _mergeProps(otherProps, { onTogglePopup: _unref(handleTogglePopup) }), null, 16, ["onTogglePopup"])
    ]),
    _: 1
  }, 8, ["title", "handle-redirect"]))
}
}

})